import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const GoogleAnalytics = () => {
  const location = useLocation();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize GA4 with the Measurement ID from environment variables
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    
    if (measurementId) {
      try {
        ReactGA.initialize(measurementId);
        setIsInitialized(true);
      } catch (error) {
        console.error("Failed to initialize Google Analytics:", error);
      }
    } else {
      console.warn("Google Analytics Measurement ID is missing in environment variables.");
    }
  }, []);

  useEffect(() => {
    // Send pageview only after GA is initialized
    if (isInitialized) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location, isInitialized]);

  return null;
};

export default GoogleAnalytics;
